var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.query.id)?_c('TeamDirectoryDetail',{key:_vm.$route.query.id}):_c('TeamDirectoryListing')
}
var staticRenderFns = []

export { render, staticRenderFns }